export enum QuestionType {
    CHECKBOX = '1',
    RADIO = '2',
    TEXT = '5',
    TEXTAREA = '6',
    NUMBER = '7',
    EXEC_DATE = 'd',
    FILE = 'f',
    GOOGLE_MAPS_PLACE = 'l',
    MONTH_PICKER = 'm',
    MOMENT_PICKER = 'v',
}
